import pl from "@locales/store_session/pl.json";
import en from "@locales/store_session/en.json";

export default { pl, en };
